import classNames from 'classnames/bind';
import { useMediaQuery } from 'react-responsive';

import styles from './S03.module.scss';

const cx = classNames.bind(styles);

const S03 = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 734px)' });

  return (
    <div className={cx('container')}>
      <p className={cx('desc')}>귀리를 통으로 우려내 진한 곡물향을 그대로</p>
      <h2 className={cx('headline')}>풀무원 하루귀리</h2>
      <div className={cx('columns')}>
        <div className={cx('left')}>
          {!isMobile && <img src={require('../../../assets/images/products/oneday/s03/box.png')} alt="" />}
          {isMobile && <img src={require('../../../assets/images/products/oneday/s03/box-mo.png')} alt="" width="90%" />}
        </div>
        <div className={cx('right')}>
          <div className={cx('text1')}>귀리는?</div>
          <div className={cx('text2')}>
            <strong>수용성 섬유질</strong>이며, 베타글루칸, 라이신 등<br />
            <strong>필수 아미노산과 칼슘이 함유</strong>되어 있는 곡물입니다.
          </div>
          <div className={cx('text3')}>
            *출처 : 한국농수산식품유통공사
            <br />
            *제품에 대한 설명이 아닌 귀리 원료에 대한 설명입니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default S03;
